/******************************************************
/******************************************************
 *                  Global exploitation Ctrl
 ********************************************************/

"use strict";


angular.module("exploitation")

	.controller("ExploitRoutesPointsArretCtrl", [
		"$scope", "$location", "$anchorScroll", "$routeParams", "ExploitRoutesPointsArretService", "OkinaLeafletService", "leafletData", "CartoService", "ExploitationService", "StopAreasService", "EitiPointsBusinessService", "MapService", "CONSTANTS", "Utils", "$uibModal", "toastr",
		function ($scope, $location, $anchorScroll, $routeParams, ExploitRoutesPointsArretService, OkinaLeafletService, leafletData, CartoService, ExploitationService, StopAreasService, EitiPointsBusinessService, MapService, CONSTANTS, Utils, $uibModal, toastr) {

		$scope.LeafletService = OkinaLeafletService;

		/******************************************************
		 *                  SETUP
		 ********************************************************/
		var deleteStopPointModal;
		var mergeStopAreasModal;
		var fusion30mpendingModal;
		var validateEditedPointsModal;
		var duplicateStopAreaModal;
		var removeStopPointModal;
		var impactInfoModal;
		var duplicateStopArea;

		$scope.data = {
			networks: [],
			lines: [],
			routes: [],

			routeId: 0,
			currentLine: 0,

			currentRouteData: {
				stop_points: [],
			},

			editMode: false,
			workStarted: false,
			currentStopPoint: {},
			stopPointBeforeChange: {},
			stopPointsToValidate: {},
			selectedMapPointId: 0,

			stopPointDelete: {
				impactList : [],
				deleteList : []
			},

			asTheCrowFlies      : false,
			showDuplicatePoints : false,

			stopAreas30m        : {
				checkboxStopArea30m: {},
				stop_points: null
			},

			explPopover                : {
				showStopArea30m      : {},
				duplicateStopArea    : {},
				validateEditedPoints : {},
				removeStopPoints     : {},
				removeStopPointBack  : {},
				verifyStopAreas      : {}
			}
		};

		init();

		function init()
		{
			OkinaLeafletService.init("mapId", {
				zoomOffset: {
					paddingTopLeft: [-450, 0]
				}
			});

			OkinaLeafletService.setCenter({
				lat: 48.8566969,
				lng: 2.3514616,
				zoom: 9
			});

			if ($routeParams.routeId) {
				ExploitationService.getRouteAndNbStopArea30m($routeParams.routeId).then((response) => {
					const stopPointsData = response.data;
					//$scope.data.currentRouteData = stopPointsData;
					$scope.data.currentNetwork = stopPointsData.network;
					ExploitationService.getLines($scope.data.currentNetwork).then((response) => {
						//$scope.data.currentRouteData = stopPointsData;
						$scope.data.lines = response.data;
						$scope.data.currentLine = stopPointsData.line;
						ExploitationService.getRoutes($scope.data.currentLine).then((response) =>  {
							//$scope.data.currentRouteData = stopPointsData;
							$scope.data.routes = response.data;
							$scope.journeySelected( $routeParams.routeId);
						});
					});
				});
			}
		}

		/******************
		 * SCOPE FUNCTIONS
		 ******************/
		/**
		 * Specify which popup will be used when points get clicked on map.
		 * @type {.featureTemplates.routeStopPoint|*}
		 */


		/**
		 * Pour les popover
		 * @param model
		 * @param id
		 * @param show
		 */
		$scope.explPopover = function( model, id, show)
		{
			$scope.data.explPopover[ model][id] = show;
		};

		/**
		 * Redirect to correct application route when a route is selected
		 *
		 * @param routeId
		 */

		$scope.lineCHangeCallback = function()
		{
			$scope.data.currentRouteData     = { stop_points: [] };
			$scope.data.stopPointDelete      = { impactList : [], deleteList : [] };
			$scope.data.routeId              = null;
			$scope.data.workStarted          = false;
			$scope.closeStopAreas30m();
			ExploitRoutesPointsArretService.cleanMap();
		};


		$scope.journeySelected = function( routeId)
		{
			$scope.data.routeId               = routeId;
			$scope.data.currentRouteData      = { stop_points: [] };
			$scope.data.editMode              = false;
			$scope.data.currentStopPoint      = {};
			$scope.data.stopPointDelete       = { impactList : [], deleteList : [] };
			$scope.data.stopAreas30m          = { checkboxStopArea30m: {}, stop_points: null };
			$scope.data.selectedMapPointId    = 0;
			$scope.data.asTheCrowFlies        = false;
			$scope.data.showDuplicatePoints   = false;
			$scope.data.workStarted           = false;
			if ( !routeId ) return;


			ExploitationService.getRouteAndNbStopArea30m( routeId).then((response) =>  {
				$scope.data.currentRouteData        = response.data;

				ExploitationService.getGeoJsonTrace( routeId).then((response) => {
					$scope.data.currentRouteData.geojson = response.data.geojson;
					drawJourneyPattern( $scope.data.currentRouteData, true, true);
				});
			});
		};

		$scope.updateStopPoint = function( routeId)
		{
			ExploitationService.getRouteAndNbStopArea30m( routeId).then((response) => {
				const currentRouteData = response.data;
				for (let index in $scope.data.currentRouteData.stop_points) {
					let sp = $scope.data.currentRouteData.stop_points[ index];
					if (sp.id === $scope.data.currentStopPoint.id){
						let hide        = sp.id;
						let isDeparture = $scope.data.currentStopPoint.isDeparture;
						let isArrival   = $scope.data.currentStopPoint.isArrival;
						let numero      = $scope.data.currentStopPoint.index + 1;
						$scope.data.currentRouteData.stop_points[ index]             = angular.copy( currentRouteData.stop_points[index]);
						$scope.data.currentRouteData.stop_points[ index].isDeparture = isDeparture;
						$scope.data.currentRouteData.stop_points[ index].isArrival   = isArrival;
						$scope.hideStopPoint( hide);
						$scope.showStopPoint( $scope.data.currentRouteData.stop_points[ index], true, numero);
						$scope.data.currentStopPoint = $scope.data.currentRouteData.stop_points[ index];
					}
				}
			});
		};


		function drawJourneyPattern( jp, shouldZoom, draggable, zoomOn) {
			ExploitRoutesPointsArretService.cleanMap( $scope.data.workStarted);

			if ($scope.data.asTheCrowFlies) {
				ExploitRoutesPointsArretService.displayAsTheCrowFliesVJ(jp);
			} else {
				CartoService.displayTopologyJourneyPattern(jp);
			}
			if ( !$scope.data.workStarted ) {
				ExploitRoutesPointsArretService.drawStopAreasFromPattern(jp, $scope, null, null, draggable, zoomOn);
				if( ( $scope.data.asTheCrowFlies) && ( $scope.data.currentRouteData.id) ){
					for ( var index in $scope.data.routes){
						var route = $scope.data.routes[ index];
						if ( route.id = $scope.data.currentRouteData.id) {
							ExploitRoutesPointsArretService.drawStopAreasFromPattern(jp, $scope, "orange", null, false);
						}
					}
				}
			}

			if (shouldZoom && !zoomOn) {
				OkinaLeafletService.zoomToVisibleElements();
			}
		}

		$scope.swicthAsTheCrowFlies = function()
		{
			$scope.data.asTheCrowFlies = !$scope.data.asTheCrowFlies;
			if ( !$scope.data.currentRouteData.id) return;

			OkinaLeafletService.deleteGeoJsonLayers();

			if ($scope.data.asTheCrowFlies) {
				ExploitRoutesPointsArretService.displayAsTheCrowFliesVJ( $scope.data.currentRouteData);
			} else {
				CartoService.displayTopologyJourneyPattern($scope.data.currentRouteData);
			}
		};

		$scope.hideStopPoint = function( spId)
		{
			var markerId = spId || ExploitRoutesPointsArretService.STOP_POINT_MARKER_ID;
			ExploitRoutesPointsArretService.getCurrentlyDrawnMarkerById( markerId, function (marker) {
				OkinaLeafletService.deleteMarker(marker);
			});
		};

		$scope.showStopPoint = function( stopPoint, useAsSP, index)
		{
			var latitude         = stopPoint.latitude;
			var longitude        = stopPoint.longitude;

			// Parse latitude and longitude if they're not numbers because we store them as String in DB
			if (typeof latitude !== "number") {
				latitude = parseFloat(latitude);
			}
			if (typeof longitude !== "number") {
				longitude = parseFloat(longitude);
			}

			var color = "orange";
			if ( useAsSP ) {
				color = "blue";
				if (stopPoint.isDeparture) {
					color = "green";
				} else if (stopPoint.isArrival) {
					color = "red";
				}
			}

			var stopPointMarker = {
				lat: latitude,
				lng: longitude,
				focus: true,
				id: useAsSP ? stopPoint.id : ExploitRoutesPointsArretService.STOP_POINT_MARKER_ID,
				message: useAsSP ? ExploitRoutesPointsArretService.popupRouteStopPointTemplate( stopPoint) : stopPoint.name,
				draggable: true,
				icon: {
					type: index ? "extraMarker" : "awesomeMarker",
					icon: index ? "fa-number"     : "circle",
					number: index,
					prefix: index ? null : "fa",
					markerColor: color,
					iconColor: stopPoint.isValidated ? "black" : "white"
				}
			};

			OkinaLeafletService.createMarkerWithName( ExploitRoutesPointsArretService.STOP_POINT_MARKER_ID, stopPointMarker);
			ExploitRoutesPointsArretService.getCurrentlyDrawnMarkerById( ExploitRoutesPointsArretService.STOP_POINT_MARKER_ID, function (marker) {
				if (marker !== null) {
					if ( useAsSP ) {
						marker.on( "mousedown", function(event){
							$scope.$apply(function () {
								$scope.data.selectedMapPointId = marker.options.id;
								$scope.enterEditButtonMode( stopPoint, true);
								$scope.data.currentStopPoint = stopPoint;
							});
						});
						marker.on("drag", function (event) {
							$scope.$apply(function () {
								$scope.data.currentStopPoint.longitude  = event.latlng.lng;
								$scope.data.currentStopPoint.latitude   = event.latlng.lat;
								$scope.data.currentStopPoint.isModified = true;
							});
						});
					} else {
						marker.setZIndexOffset(100);
						marker.openPopup();
					}
				}
			});
		};

		$scope.duplicateStopArea = function()
		{
			let jpId = $scope.data.currentRouteData.id;
			let spId = $scope.data.currentStopPoint.id;
			duplicateStopAreaModal.close();
			if ( !jpId || !spId ) return;
			StopAreasService.duplicateStopArea(spId, jpId)
				.then(() => {
					toastr.success( "Affectation du poteau d'arrêt d'en face réussie");
					$scope.updateStopPoint( $scope.data.currentRouteData.id);
				})
				.catch(() => {
					toastr.error("Le poteau d'arrêt n'a pas pu été traité");
				});
		};

		$scope.showStopArea30m = function( stopPoint)
		{
			StopAreasService.getStopArea30m(stopPoint.id)
				.then((response) => {
					$scope.data.stopAreas30m.stop_points = response.data;
				});
		};

		$scope.closeStopAreas30m = function()
		{
			$scope.data.stopAreas30m     = { checkboxStopArea30m: {}, stop_points: null};
		};

		/**
		 * Used to return a dufferent image for markers in the stop point list, according thir position in the list.
		 * @param rank
		 * @returns {*}
		 */
		$scope.getImageByRank = function (rank) {
			if (rank === 0) {
				return CONSTANTS.MAP_MARKER_START;
			} else if (rank === $scope.data.currentRouteData.stop_points.length - 1) {
				return CONSTANTS.MAP_MARKER_END;
			} else {
				return CONSTANTS.MAP_MARKER_DEFAULT;
			}
		};

		/**
		 * Used to highlight elements in the stop point list.
		 * @param stopPoint
		 * @returns {boolean}
		 */
		$scope.isStopPointSelected = function (stopPoint) {
			return $scope.data.currentStopPoint === stopPoint;
		};

		$scope.isStopPointSelectedOnMap = function( id)
		{
			return id === $scope.data.currentStopPoint.id;
		};

		$scope.isJourneyPatternSelected = function( id)
		{
			return id === $scope.data.currentRouteData.id;
		};

		$scope.goMapMatching = function () {
			var path = "e-iti/itineraires/" + $scope.data.routeId + "/map-matching/itineraires-points-arret";
			$location.path( path);
		};

		$scope.removeStopPoints = function(){
			removeStopPointModal.close();
			ExploitationService.removeDuplicateStopPoint( $scope.data.currentRouteData.id)
				.then(() => {
					toastr.success( "La séquence de points d'arrêt de l'itinéraire a été nettoyée");
					$scope.journeySelected( $scope.data.currentRouteData.id);
				})
				.catch(function () {
					toastr.error("La séquence de points d'arrêt de l'itinéraire n'a pas été nettoyée\"");
				});
		};

		$scope.enterEditButtonMode = function ( stopPoint, noZoom) {
			$scope.data.workStarted = true;
			window.scrollTo( 0,document.body.scrollHeight);
			$scope.data.editMode              = true;
			$scope.data.stopPointBeforeChange = angular.copy( stopPoint);
			ExploitationService.setCurrentStopPoint(stopPoint);

			var latitude  = stopPoint.latitude;
			var longitude = stopPoint.longitude;
			if (latitude != null && typeof latitude !== "number") {
				latitude = parseFloat(latitude);
			}
			if (longitude != null && typeof longitude !== "number") {
				longitude = parseFloat(longitude);
			}
			$scope.data.stopAreas30m = { checkboxStopArea30m: {}, stop_points: null};
			$scope.showStopArea30m( stopPoint);
			$scope.data.currentStopPoint = stopPoint;

			if ( noZoom ) return;
			OkinaLeafletService.setCenter( { lat: latitude, lng: longitude, zoom: 18}, false);
		};

		$scope.mergeStopAreas30m = function()
		{
			fusion30mpendingModal = Utils.openModal($uibModal, "fusion30mpending.html", $scope);
			mergeStopAreasModal.close();
			var into = $scope.data.currentStopPoint.id;
			var l    = 0;
			var nb   = $scope.data.stopAreas30m.stop_points.length;
			for ( var cb in $scope.data.stopAreas30m.checkboxStopArea30m){
				if ( !$scope.data.stopAreas30m.checkboxStopArea30m[ cb] ) continue;
				l++;
			}
			if ( l == 0) return;
			var c = 0;
			for ( var cb in $scope.data.stopAreas30m.checkboxStopArea30m) {
				if ( !$scope.data.stopAreas30m.checkboxStopArea30m[ cb] ) continue;
				var from = parseInt( cb);
				StopAreasService.mergeStopArea30m( from, into)
					.then(() => {
						c++;
						if ( c !== l) return;
						if ( c == nb ){
							$scope.data.currentStopPoint.nbClosedStopAreas = 0;
						}
						$scope.closeStopAreas30m();
						toastr.success("Point(s) d'arrêt fusionné(s", "");
					})
					.finally(() => {
						fusion30mpendingModal.close();
					});
			}
		};
		$scope.verifyStopAreas = function( stopPoint, index)
		{
			$scope.data.currentStopPoint       = stopPoint;
			$scope.data.currentStopPoint.index = index;
			let routeData                      = angular.copy($scope.data.currentRouteData);
			routeData.stop_points              = routeData.stop_points.filter( function(e){
					return e.stop_point_id !== $scope.data.currentStopPoint.stop_point_id;
				});

			$scope.data.stopPointDelete.impactList = [];
			ExploitationService.analyseDeleteStopPointsRoute(
				routeData,
				$scope.data.currentNetwork,
				$scope.data.currentLine,
				$scope.data.currentRouteData.id)
				.then((response) => {
					$scope.data.stopPointDelete.impactList = response.data;
					impactInfoModal                        = Utils.openModal($uibModal, "impactInfoModal.html", $scope);
				})
				.catch(function () {
					toastr.error("Problème lors de l'analyse des impacts.", "Erreur");
				});
		};

		$scope.validateDeletion = function()
		{
			impactInfoModal.close();
			$scope.data.currentRouteData.stop_points =  $scope.data.currentRouteData.stop_points.filter( function(e){
				return e.stop_point_id !== $scope.data.currentStopPoint.stop_point_id;
			});
			$scope.data.stopPointDelete.deleteList.push( $scope.data.currentStopPoint);
			$scope.hideStopPoint( $scope.data.currentStopPoint.id);
		};

		/**
		 * Will duplicate stopareas of the current journeypattern
		 */
		$scope.duplicateStopAreas = function()
		{
			$scope.data.workStarted = false;
			const journey             = $scope.data.currentRouteData.id.toString();
			const spIds               = $scope.data.stopPointDelete.deleteList.map( e => e.stop_point_id);

			if ( spIds.length ) {
				ExploitationService.removeStopPoints($scope.data.currentRouteData.id, spIds)
					.catch(function (e) {
						toastr.error("Problème lors de la suppression de points d'arrêt.", e.message);
					})
					.finally(function () {
						$scope.data.stopPointDelete = { impactList : [], deleteList : [] };
						doDuplication( journey);
					});
			} else {
				doDuplication( journey);
			}
		};

		function doDuplication( journey)
		{
			StopAreasService.duplicateStopAreasFromJourney(journey)
				.then(() => {
					$scope.journeySelected($scope.data.currentRouteData.id);

					let routeIds = $scope.data.routes.map(function (e) {
						return e.id;
					}).join(",");
					ExploitationService.checkAndInitGeoJson(routeIds)
						.catch(function (e) {
							toastr.error("Problème lors de la récupération des tracés.", e.message);
						});

					$scope.data.routes.forEach(function (route) {
						if (route.id == journey) route.isDuplicated = true;
					});

					toastr.success("Points d'arrêt de l'itinéraire dupliqués", "");
				})
				.catch(function (e) {
					toastr.error("Problème lors de la duplication.", e.message);
				});
		};

		/**
		 * Open modals
		 */

		$scope.openValidateEditedPointsModal = function()
		{
			validateEditedPointsModal = Utils.openModal($uibModal, "validateEditedPoints.html", $scope);
		};

		$scope.openMergeStopAreas30mModal = function()
		{
			mergeStopAreasModal = Utils.openModal($uibModal, "mergePoints30m.html", $scope);
		};

		$scope.openDeleteStopPointModal = function( stopPoint)
		{
			$scope.data.currentStopPoint = stopPoint;
			deleteStopPointModal         = Utils.openModal($uibModal, "deletePoints.html", $scope);
		};

        $scope.openRemoveStopPointsModal = function()
		{
			removeStopPointModal = Utils.openModal($uibModal, "removeStopPoints.html", $scope);
		};
		$scope.openDuplicateStopAreaModal = function( stopPoint, index)
		{
			$scope.data.currentStopPoint       = stopPoint;
			$scope.data.currentStopPoint.index = index;
			duplicateStopAreaModal = Utils.openModal($uibModal, "duplicateStopArea.html", $scope);
		};

		$scope.postEditedPoint = function()
		{
			var stopPoint = angular.copy($scope.data.currentStopPoint);
			$scope.data.stopPointsToValidate[ stopPoint.id] = stopPoint;
			for( var index in $scope.data.currentRouteData.stop_points){
				var sp = $scope.data.currentRouteData.stop_points[ index];
				if ( sp.id != stopPoint.id) continue;
				$scope.data.currentRouteData.stop_points[ index].isModified = true;
			}

			ExploitRoutesPointsArretService.cleanMap();
			drawJourneyPattern( $scope.data.currentRouteData, true);
			$scope.data.currentStopPoint = {};
			$scope.data.editMode = false;
		};

		$scope.clickStopPointIsUnique = function( stopPoint)
		{
			stopPoint.isModified = true;
		};


		$scope.validateJourneyPattern = function () {
			// send data
			validateEditedPointsModal.close();
			var nbModifiedStopPoints = $scope.data.currentRouteData.stop_points.filter( function(e){ return e.isModified; }).length;
			var compteur             = 0;

			if ( !nbModifiedStopPoints ) {
				$scope.duplicateStopAreas();
			} else {
				for (var index in $scope.data.currentRouteData.stop_points) {
					var stopPoint = $scope.data.currentRouteData.stop_points[index];
					if ((stopPoint.isModified === undefined) || !stopPoint.isModified) continue;
					if ((stopPoint.isDeleted !== undefined) && stopPoint.isDeleted) continue;
					ExploitationService.updateStopAreaBoarding(stopPoint)
						.catch(function (data) {
							var errorMessage = "Problème lors de l'enregistrement des points. ";
							if (data !== undefined && data.message) {
								errorMessage += data.message;
							}
							toastr.error(errorMessage, "Erreur");
						})
						.finally(function () {
							compteur++;
							if (compteur != nbModifiedStopPoints) return;
							console.log("> compteur=" + compteur + " -- nbModifiedStopPoints" + nbModifiedStopPoints);
							$scope.duplicateStopAreas();
							ExploitationService.updateOsrmProfileJourneyPatterns(stopPoint);
						});
				}
			}
		};

		/******************
		 * WATCHERS
		 ******************/

		$scope.$watchCollection("data.routes", function (value, oldValue) {
			if ( !value.length) return;
			var routeIds = value.map( function( e){ return e.id; }).join(",");
			ExploitationService.checkAndInitGeoJson( routeIds)
				.error( function( e){
					if ( !e) return;
					toastr.error("Problème lors de la récupération des tracés.", e.message);
				});
		});
	}]);
